export default "__VITE_ASSET__D$Byia0P__"